import { Badge, Group } from '@mantine/core';
import { IconCircleFilled } from '@tabler/icons-react';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { useResultsQuickFilters } from '../../hooks/use-results-quick-filters';
import { GES_STATUS_STAT_ORDER } from '../../lib/results-stats';
import { getGesStatusMeta } from '../../utils/ges-status';

import classes from './results-header.module.css';

export const ResultsQuickFilters: FC = () => {
  const { t } = useTranslation();
  const { activeStatuses, toggleGesStatus } = useResultsQuickFilters();

  return (
    <Group className={classes.toolbarPills} gap="xs" wrap="wrap">
      {GES_STATUS_STAT_ORDER.map((status) => {
          const meta = getGesStatusMeta(status);
          const active = activeStatuses.has(status);
          const color = meta?.color ?? 'gray';

          return (
            <Badge
              className={classes.pill}
              color={active ? color : 'gray'}
              key={status}
              leftSection={
                meta ? (
                  <IconCircleFilled
                    color={active ? '#fff' : meta.hexColor}
                    size={10}
                  />
                ) : undefined
              }
              onClick={() => toggleGesStatus(status)}
              radius="xl"
              size="md"
              variant={active ? 'filled' : 'light'}
            >
              {t(`sampling.results.stats.ges_${status}`)}
            </Badge>
          );
      })}
    </Group>
  );
};

